// Supplementary column presets for the Actuals vs Budget report tables.
//
// The three time bases (Month, Reporting Period, Lifetime — each showing
// Budget / Actuals / Variance) are ALWAYS rendered and are not represented
// here. These constants describe only the *supplementary* columns whose
// visibility the column presets and the "Customise columns" grid control.

export const COL_COMMITTED = 'committed';
export const COL_UNCOMMITTED = 'uncommitted';
export const COL_PERCENT = 'percent';
export const COL_RISK = 'risk';
export const COL_OPPORTUNITY = 'opportunity';
export const COL_FORECAST = 'forecast';
// Monthly phasing = the per-month columns already rendered by the Detailed
// table. It is a detailed-table-only concept (the summary tables have no
// per-month columns), so summary rendering ignores it.
export const COL_MONTHLY_PHASING = 'monthly_phasing';

// Supplementary columns available in the summary tables (no monthly phasing).
export const SUMMARY_SUPPLEMENTARY_COLUMNS = [COL_COMMITTED, COL_UNCOMMITTED, COL_PERCENT, COL_RISK, COL_OPPORTUNITY, COL_FORECAST];

// The detailed table additionally exposes monthly phasing.
export const DETAILED_SUPPLEMENTARY_COLUMNS = [...SUMMARY_SUPPLEMENTARY_COLUMNS, COL_MONTHLY_PHASING];

export const PRESET_BOARD = 'board';
export const PRESET_STANDARD = 'standard';
export const PRESET_FULL = 'full';

export const DEFAULT_COLUMN_PRESET = PRESET_STANDARD;

// Which supplementary columns each preset switches on.
//   Board summary — none (just the three time bases).
//   Standard      — Committed, Uncommitted, Forecast.
//   Full          — everything, including monthly phasing.
const PRESET_COLUMNS = {
    [PRESET_BOARD]: [],
    [PRESET_STANDARD]: [COL_COMMITTED, COL_UNCOMMITTED, COL_FORECAST],
    [PRESET_FULL]: DETAILED_SUPPLEMENTARY_COLUMNS,
};

/**
 * Build the visible-columns map for a preset: every supplementary column key
 * mapped to a boolean. This is the value the "Customise columns" overrides
 * mutate and both tables consume.
 *
 * @param {string} preset
 * @returns {Object<string, boolean>}
 */
export function columnsForPreset(preset) {
    const enabled = PRESET_COLUMNS[preset] || [];

    return DETAILED_SUPPLEMENTARY_COLUMNS.reduce((acc, key) => {
        acc[key] = enabled.includes(key);
        return acc;
    }, {});
}
